export default __webpack_public_path__ + "static/media/037-headstone.e8d9fd30.svg";